module.exports = __webpack_public_path__ + "img/sa1.85a126cb.png";